<div class="mt-5">
    <div class="relative">
        <div class="titel w-full g-bg-secondary sticky p-2 shadow-5">
            <div class="flex align-items-center gap-2 ">
                <div>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" rx="16" fill="#ffffff" />
                        <g clip-path="url(#clip0_1023_2382)">
                            <path
                                d="M20 21C22.396 21 24.575 21.694 26.178 22.672C26.978 23.16 27.662 23.736 28.156 24.362C28.642 24.977 29 25.713 29 26.5C29 27.345 28.589 28.011 27.997 28.486C27.437 28.936 26.698 29.234 25.913 29.442C24.335 29.859 22.229 30 20 30C17.771 30 15.665 29.86 14.087 29.442C13.302 29.234 12.563 28.936 12.003 28.486C11.41 28.01 11 27.345 11 26.5C11 25.713 11.358 24.977 11.844 24.361C12.338 23.736 13.021 23.161 13.822 22.671C15.425 21.695 17.605 21 20 21ZM20 10C21.3261 10 22.5979 10.5268 23.5355 11.4645C24.4732 12.4021 25 13.6739 25 15C25 16.3261 24.4732 17.5979 23.5355 18.5355C22.5979 19.4732 21.3261 20 20 20C18.6739 20 17.4021 19.4732 16.4645 18.5355C15.5268 17.5979 15 16.3261 15 15C15 13.6739 15.5268 12.4021 16.4645 11.4645C17.4021 10.5268 18.6739 10 20 10Z"
                                fill="#241C0B" />
                        </g>
                        <defs>
                            <clipPath id="clip0_1023_2382">
                                <rect width="24" height="24" fill="white" transform="translate(8 8)" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div>
                    {{user.name}}
                </div>
            </div>
        </div>

        <div class="body g-bg-secondary flex flex-column overflow-y-auto pt-2 px-5 scroll-container"
            style="height: calc(60vh);">

            <ng-container *ngFor="let message of messageTimeLine; let last = last; trackBy: trackByMessageId">
                <!-- {{last|json}} -->
                <div *ngTemplateOutlet="messageTemplate; context: { 
              username: message.sender_name, 
              message: message.message, 
              time: message.created_at | sinceDate, 
              isSender: !message.is_sender,
              id: last? 'lastMessage' : null
            }">
                </div>
            </ng-container>
        </div>

        <div class="footer g-bg-secondary">
            <div class="flex align-items-center w-12 grid">
                <div class="col-1 flex justify-content-center align-items-center">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" rx="16" fill="white" />
                        <path
                            d="M20 21C22.396 21 24.575 21.694 26.178 22.672C26.978 23.16 27.662 23.736 28.156 24.362C28.642 24.977 29 25.713 29 26.5C29 27.345 28.589 28.011 27.997 28.486C27.437 28.936 26.698 29.234 25.913 29.442C24.335 29.859 22.229 30 20 30C17.771 30 15.665 29.86 14.087 29.442C13.302 29.234 12.563 28.936 12.003 28.486C11.41 28.01 11 27.345 11 26.5C11 25.713 11.358 24.977 11.844 24.361C12.338 23.736 13.021 23.161 13.822 22.671C15.425 21.695 17.605 21 20 21ZM20 10C21.3261 10 22.5979 10.5268 23.5355 11.4645C24.4732 12.4021 25 13.6739 25 15C25 16.3261 24.4732 17.5979 23.5355 18.5355C22.5979 19.4732 21.3261 20 20 20C18.6739 20 17.4021 19.4732 16.4645 18.5355C15.5268 17.5979 15 16.3261 15 15C15 13.6739 15.5268 12.4021 16.4645 11.4645C17.4021 10.5268 18.6739 10 20 10Z"
                            fill="#241C0B" />
                    </svg>
                </div>
                <div class="col-9">
                    <input pInputText placeholder="اكتب ردا" (keydown.enter)="sendMessage()" class="w-full"
                        [(ngModel)]="message">
                </div>
                <div class="col-2 flex justify-content-center align-items-center">
                    <p-button (onClick)="sendMessage()" class="w-12" icon="pi pi-send" label="إرسال"></p-button>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #messageTemplate let-username="username" let-id="id" let-message="message" let-time="time"
    let-isSender="isSender">
    <div [ngClass]="{'receiver-message':!isSender, 'sender-message': isSender}" [id]="id">
        <!-- Message Header -->
        <div class="message-header">
            <svg width="40" height="40" [attr.fill]="isSender?'#CEB178':'white'" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="16" />
                <g clip-path="url(#clip0_1023_2382)">
                    <path
                        d="M20 21C22.396 21 24.575 21.694 26.178 22.672C26.978 23.16 27.662 23.736 28.156 24.362C28.642 24.977 29 25.713 29 26.5C29 27.345 28.589 28.011 27.997 28.486C27.437 28.936 26.698 29.234 25.913 29.442C24.335 29.859 22.229 30 20 30C17.771 30 15.665 29.86 14.087 29.442C13.302 29.234 12.563 28.936 12.003 28.486C11.41 28.01 11 27.345 11 26.5C11 25.713 11.358 24.977 11.844 24.361C12.338 23.736 13.021 23.161 13.822 22.671C15.425 21.695 17.605 21 20 21ZM20 10C21.3261 10 22.5979 10.5268 23.5355 11.4645C24.4732 12.4021 25 13.6739 25 15C25 16.3261 24.4732 17.5979 23.5355 18.5355C22.5979 19.4732 21.3261 20 20 20C18.6739 20 17.4021 19.4732 16.4645 18.5355C15.5268 17.5979 15 16.3261 15 15C15 13.6739 15.5268 12.4021 16.4645 11.4645C17.4021 10.5268 18.6739 10 20 10Z"
                        fill="#241C0B" />
                </g>
                <defs>
                    <clipPath id="clip0_1023_2382">
                        <rect width="24" height="24" fill="white" transform="translate(8 8)" />
                    </clipPath>
                </defs>
            </svg>
            <span>{{ username }}</span>
        </div>

        <!-- Message Body -->
        <div [ngClass]="{'g-bg-primary':!isSender ,'text-white':!isSender, 'bg-white':isSender,'text-black': isSender}"
            class="my-2 p-3  break-words" style="border-radius: 10px;
                                                 overflow-wrap: break-word; 
                                                 word-wrap: break-word; ">
            {{ message }}
        </div>

        <!-- Time -->
        <span class="text-gray-500 font-semibold">{{ time }}</span>
    </div>
</ng-template>